<template>
  <div>
    <v-row justify="start">
      <v-col cols="12" sm="4" md="3" class="ml-3">
        <v-text-field
          id="campo_pesquisar"
          v-model="searchQuery"
          @input="filtrar"
          append-icon="search"
          :label="$t('label.pesquisar')"
          single-line
          clearable
          hide-details>
        </v-text-field>
      </v-col>
      <v-col cols="12" :sm="filtroGrupoFornecedor.idsGrupoFornecedor.length ? 6 : 4" :md="filtroGrupoFornecedor.idsGrupoFornecedor.length ? 6 : 3">
        <v-autocomplete
          id="fornecedor-autocomplete-grupo-fornecedor"
          class="custom-autocomplete"
          v-model="filtroGrupoFornecedor.idsGrupoFornecedor"
          :label="`${$tc('label.grupo_fornecedor', 1)}`"
          :items="gruposFornecedores"
          item-value="shortCode"
          clearable
          clear-on-select
          multiple
          chips
          deletable-chips
          @click:append="() => triggerSelecao('fornecedor-autocomplete-grupo-fornecedor')"
          @click.native="(i) => buscaAutocomplete(i, buscarGruposFornecedores)"
          :search-input.sync="triggerGrupoFornecedor"
          @change="filtrar">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="1" align-self="center">
        <v-row>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn id="btn_exportar" icon :disabled="bloquearBotaoExportacao" class="mx-0" v-on="on" @click="exportar()">
                <v-icon>get_app</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('label.exportar') }}</span>
          </v-tooltip>

          <v-tooltip bottom v-show="canAccessCRUD && selected.length > 0">
            <template v-slot:activator="{ on }">
              <v-btn text icon id="btn_ativar_inativar" class="mx-0" v-on="on" @click="ativarInativar()">
                <v-icon>block</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('label.ativar_inativa') }}</span>
          </v-tooltip>
        </v-row>
      </v-col>
    </v-row>

    <v-data-table
      id="tabela_fornecedores"
      v-model="selected"
      :headers="headersDinamico"
      :items="fornecedores"
      :options.sync="pagination"
      show-select
      :server-items-length="totalPage"
      :no-data-text="$t('label.tabela_sem_conteudo')"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50],
      }"
      >
      <template v-slot:item="{ item, isSelected, select }">
        <tr :key="item.name" :class="{ 'TableRow--disabled': !item.indAtivo }">
          <td>
            <v-simple-checkbox :value="isSelected" @input="select($event)"></v-simple-checkbox>
          </td>
          <td class="justify-center px-0" style="width: 1%; text-align: center;">
            <v-tooltip bottom v-if="canAccessCRUD">
              <template v-slot:activator="{ on }">
                <v-btn icon class="mx-0" v-on="on" @click.stop="editar(item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('label.editar') }}</span>
            </v-tooltip>
            <v-tooltip bottom v-if="!canAccessCRUD">
              <template v-slot:activator="{ on }">
                <v-btn icon class="mx-0" v-on="on" @click="ver(item)">
                  <v-icon>equalizer</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('label.mais_detalhes') }}</span>
            </v-tooltip>
          </td>
          <td>{{ item.idExterno }}</td>
          <td>{{ item.desRazaoSocial }}</td>
          <td>{{ item.desNomeFantasia }}</td>
          <td>{{ item.desCnpj }}</td>
          <td
            v-for="(coluna, indice) in colunasTabelaLinha"
            :key="`coluna-${coluna.tipo}-${coluna.entidade || 'origem'}-${indice}`">
            {{ getValorColunaTabela(coluna, item) }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { buscaAutocomplete, triggerSelecao } from '@/common/functions/autocomplete-utils';
import * as metadados from '@/common/functions/metadados';
import FornecedorContato from './FornecedorContato';

export default {
  name: 'FornecedorListDados',
  props: {
    canAccessCRUD: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fornecedorResources: this.$api.fornecedor(this.$resource),
      extensaoResources: this.$api.extensao(this.$resource),
      bloquearBotaoExportacao: false,
      fornecedores: [],
      fornecedorSelecionado: {},
      esperar: false,
      pagination: {},
      totalPage: 0,
      searchQuery: '',
      headers: [
        {
          text: '', value: 'acoes', sortable: false, width: '2%', align: 'center',
        },
        { text: this.$tc('label.codigo', 1), value: 'id_externo', sortable: true },
        { text: this.$tc('label.razao_social', 1), value: 'des_razao_social', sortable: true },
        { text: this.$tc('label.nome_fantasia', 1), value: 'des_nome_fantasia', sortable: true },
        { text: this.$tc('label.cnpj_tax_id', 1), value: 'des_cnpj', sortable: true },
      ],
      vinculo: null,
      selected: [],
      gruposFornecedores: [],
      filtroGrupoFornecedor: {
        idsGrupoFornecedor: [],
      },
      timeoutTrigger: null,
      triggerGrupoFornecedor: null,
    };
  },
  components: {
    FornecedorContato,
  },
  computed: {
    ...mapGetters('metadados', [
      'getFornecedorMetadado',
    ]),
    ...mapGetters('importacao', {
      tiposImportacao: 'getTiposImportacao',
    }),
    ...mapGetters('implantacao', [
      'indAmbienteProdutivo',
      'chaveEmpresa',
    ]),
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    ...mapGetters('roles', [
      'getTenantId',
    ]),
    isTenantEpoca() {
      return this.getTenantId === 'epoca';
    },
    isTenantMagalu() {
      return this.getTenantId === 'magalu';
    },
    isTenantKabum() {
      return this.getTenantId === 'kabum';
    },
    metadadosFornecedor() {
      if (this.getFornecedorMetadado && this.getFornecedorMetadado.mapaEntidades) {
        return this.getFornecedorMetadado;
      }
      return undefined;
    },
    headersDinamico() {
      const headers = Object.assign([], this.headers);
      if (!this.metadadosFornecedor) {
        headers.push({
          text: this.$tc('label.origem_fornecedor', 1),
          value: 'origem_fornecedor',
          sortable: true,
        });
        return headers;
      }

      let inseriuOrigemAposGrupoFornecedor = false;

      Object.keys(this.metadadosFornecedor.mapaEntidades).forEach((entidade) => {
        const mapeamentoEntidade = this.metadadosFornecedor.mapaEntidades[entidade];
        if (mapeamentoEntidade.depObrigatoria) {
          headers.push({
            text: mapeamentoEntidade.entidadeEstrangeira,
            value: mapeamentoEntidade.label,
            sortable: false,
          });

          if (this.isGrupoFornecedorEntidade(entidade)) {
            headers.push({
              text: this.$tc('label.origem_fornecedor', 1),
              value: 'origem_fornecedor',
              sortable: true,
            });
            inseriuOrigemAposGrupoFornecedor = true;
          }
        }
      });

      if (!inseriuOrigemAposGrupoFornecedor) {
        headers.push({
          text: this.$tc('label.origem_fornecedor', 1),
          value: 'origem_fornecedor',
          sortable: true,
        });
      }

      return headers;
    },
    headersDinamicoObrigatorio() {
      const headers = {};
      Object.keys(this.metadadosFornecedor.mapaEntidades).forEach((entidade) => {
        const mapeamentoEntidade = this.metadadosFornecedor.mapaEntidades[entidade];
        if (mapeamentoEntidade.depObrigatoria) {
          headers[entidade] = mapeamentoEntidade;
        }
      });
      return headers;
    },
    temGrupoFornecedorObrigatorio() {
      return Object.keys(this.headersDinamicoObrigatorio)
        .some((entidade) => this.isGrupoFornecedorEntidade(entidade));
    },
    colunasTabelaLinha() {
      const colunas = [];
      Object.keys(this.headersDinamicoObrigatorio).forEach((entidade) => {
        colunas.push({ tipo: 'entidade', entidade });
        if (this.isGrupoFornecedorEntidade(entidade)) {
          colunas.push({ tipo: 'origem' });
        }
      });

      if (!this.temGrupoFornecedorObrigatorio) {
        colunas.push({ tipo: 'origem' });
      }

      return colunas;
    },
    tipoImportacao() {
      return this.tiposImportacao.find((el) => el.nome === 'importacao_produto');
    },
    isAmbienteEpoca() {
      return this.chaveEmpresa === 'EPOCA';
    },
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar();
      },
      deep: true,
    },
    searchQuery() {
      this.pagination.page = 1;
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.filtrar();
      }, 500);
    },
    triggerGrupoFornecedor(val) {
      if (this.timeoutTrigger) {
        window.clearTimeout(this.timeoutTrigger);
      }
      this.timeoutTrigger = window.setTimeout(() => {
        if (val != null) this.buscarGruposFornecedores(val);
      }, 500);
    },
  },
  methods: {
    ...metadados,
    buscaAutocomplete,
    triggerSelecao,
    normalizarTexto(valor) {
      return (valor || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
    },
    isGrupoFornecedorEntidade(entidade) {
      const mapeamentoEntidade = this.headersDinamicoObrigatorio[entidade];
      if (!mapeamentoEntidade) return false;

      const labelNormalizada = this.normalizarTexto(mapeamentoEntidade.label);
      const entidadeEstrangeiraNormalizada = this.normalizarTexto(mapeamentoEntidade.entidadeEstrangeira);

      return labelNormalizada === 'grupo_fornecedor'
        || labelNormalizada === 'grupofornecedor'
        || (entidadeEstrangeiraNormalizada.includes('grupo')
          && entidadeEstrangeiraNormalizada.includes('fornecedor'));
    },
    getValorColunaTabela(coluna, item) {
      if (coluna.tipo === 'origem') return item.origemFornecedor;
      return this.getNomesSeparadosPorVirgula(coluna.entidade, 'nomExtensao', item);
    },
    filtrar() {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        this.buscar();
      }, 1000);
    },
    buscar() {
      const params = {
        filter: this.searchQuery,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0],
      };

      if (this.filtroGrupoFornecedor.idsGrupoFornecedor.length > 0) {
        params.idsGrupoFornecedor = this.filtroGrupoFornecedor.idsGrupoFornecedor;
      }

      this.fornecedorResources.listarFiltrado(params).then((response) => {
        this.montarObjetoFornecedor(response.data.resposta);
        this.totalPage = response.data.quantidadeRegistrosPagina;
        this.pararEsperar();
        this.selected = [];
      }, (err) => {
        this.pararEsperar();
        this.$error(this, err);
      });
    },
    montarObjetoFornecedor(dados) {
      this.fornecedores = dados
        .map((data) => metadados.montarEstruturaDinamica(data, this.getFornecedorMetadado, data));
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
    editar(item) {
      this.$router.push({ name: 'editarFornecedor', params: { id: item.id } });
    },
    getSearchQuery() {
      return this.searchQuery;
    },
    getParams() {
      const params = {};

      if (this.searchQuery && this.searchQuery.length > 0) {
        params.filtro = this.searchQuery;
      }

      if (this.filtroGrupoFornecedor.idsGrupoFornecedor.length > 0) {
        params.ids_grupo_fornecedor = this.filtroGrupoFornecedor.idsGrupoFornecedor;
      }
      return params;
    },
    ver(item) {
      this.$router.push({ name: 'verFornecedor', params: { id: item.id } });
    },
    ativarInativar() {
      this.fornecedorResources.ativarMassa(this.selected)
        .then(() => {
          this.filtrar();
          this.$toast(this.$t('message.atualizado_confira_tabela'));
        }, (err) => {
          this.$error(this, err);
        });
    },
    exibeAlertaLgpd() {
      if (this.indAmbienteProdutivo) return;

      const alertaLgpd = this.$t('message.lgpd_importacao');
      alert(alertaLgpd); // eslint-disable-line
    },
    importarDados() {
      this.exibeAlertaLgpd();
      this.$emit('TABELA_IMPORTAR_DADOS');
    },
    exportar() {
      this.bloquearBotaoExportacao = true;
      this.$emit('TABELA_EXPORTAR_DADOS',
        () => { this.bloquearBotaoExportacao = false; });
    },
    buscarGruposFornecedores(filtro = null) {
      const value = {
        tamanhoPagina: 100,
        idNivelExtensao: 3,
        nome: filtro,
        usuarioLogado: this.usuarioLogado.indPerfilUsuarioExterno,
        indUsuarioExterno: this.usuarioLogado.indPerfilUsuarioExterno,
      };
      this.extensaoResources.listarExtensoes(value).then((resultado) => {
        resultado.data.resposta.forEach((el) => {
          let nomeFornecedor = el.id.toString().concat(' - ').concat(el.idExterno);
          if (this.isTenantEpoca) {
            nomeFornecedor = el.idExterno.toString().concat(' - ').concat(el.nomExtensao);
          } else if (this.isTenantKabum) {
            nomeFornecedor = el.id.toString().concat(' - ').concat(el.nomExtensao);
          }

          if (el.indAtivo) {
            nomeFornecedor = nomeFornecedor.concat(' (').concat(this.$t('label.ativo')).concat(')');
          } else {
            nomeFornecedor = nomeFornecedor.concat(' (').concat(this.$t('label.inativo')).concat(')');
          }

          const item = { shortCode: el.id, text: nomeFornecedor };
          this.gruposFornecedores.push(item);
        });
        this.filtrar();
      });
    },
  },
  mounted() {
  },
};
</script>
